var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('section',{staticClass:"main"},[_c('div',{staticClass:"container pb-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col pt-5 d-md-flex d-inline text-center justify-content-between"})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }